import { get } from "lodash"
import { numberFormatter } from "helpers/formatters/numbers"

const QUERY = `query ($modelId: String!, $positionSet: PositionSetInput!, $base: [PositionSetInput], $from: Date!, $to: Date!, $contentSetId: String) {
  model(id: $modelId) {
    simulation(positionSet: $positionSet, base: $base, from: $from, to: $to, interval: AUTO) {
      exposure(contentSetId: $contentSetId) {
        date
        factors {
          id
          name
          category
          net
          currencyExposure
        }
      }
    }
  }
}`

export function createExposureMultiDateQuery(modelId, positionSet, base, from, to) {
  return {
    key: ["exposure", "multiDate", modelId, positionSet, base, from, to],
    query: QUERY,
    variables: {
      modelId,
      positionSet,
      base,
      from,
      to,
    },
    select: (graphqlResult) => {
      const exposure = get(graphqlResult, "data.model.simulation.exposure", [])

      return {
        formatter: numberFormatter,
        values: {
          dates: exposure.map(({ date, ...dateData }) => {
            const factors = dateData.factors.reduce((acc, { id, net }) => {
              acc[id] = net
              return acc
            }, {})

            return {
              date,
              ...factors,
            }
          }),
        },
      }
    },
  }
}
